import React, { Fragment } from 'react';
import { bool, element, func, string, shape, number } from 'prop-types';
import styled from 'styled-components';
import Helmet from 'react-helmet';

import { Segment, Sidebar } from 'semantic-ui-react';

import Navbar from '~/views/common/Navbar';
import FlashIt from '~/views/common/FlashIt';
import SidebarMenu from './SidebarMenu';


const StyledSegment = styled(Segment)`
    && {
        max-width: 1440px;
        min-height: calc(100vh - ${p => p.navbarheight}px);
    }
`;


const Page = ({
    location: {
        pathname,
    },
    children,
    navbarHeight,
    MenuItems,
    isSidebarVisible,
    pageYOffset,
    handleSetPageYOffset,
    ...menuItemsProps
}) => (
    <Fragment>
        <Helmet>
            <body $hide-scroll={isSidebarVisible} />
        </Helmet>

        <Navbar />

        <FlashIt />

        <Sidebar.Pushable>
            <SidebarMenu
                isRootPath={pathname === '/'}
                visible={isSidebarVisible}
                onVisible={handleSetPageYOffset}
                navbarHeight={navbarHeight}
                pageYOffset={pageYOffset}
            >
                <MenuItems
                    pathname={pathname}
                    {...menuItemsProps}
                />
            </SidebarMenu>

            <Sidebar.Pusher>
                <StyledSegment
                    basic
                    padded="very"
                    navbarheight={navbarHeight}
                >
                    { children }
                </StyledSegment>
            </Sidebar.Pusher>
        </Sidebar.Pushable>
    </Fragment>
);


Page.propTypes = {
    location: shape({
        pathname: string.isRequired,
    }).isRequired,
    children: element.isRequired,
    isSidebarVisible: bool.isRequired,
    navbarHeight: number.isRequired,
    pageYOffset: number.isRequired,
    handleSetPageYOffset: func.isRequired,
    MenuItems: func.isRequired,
};

export default Page;
